import percent from '@pkg/utils/numbers/percent';
import applyMetrics from './metrics';
import normalize from './normalize';

export default function deriveRole({
  activity,
  deriveMetrics,
  library,
  metrics,
  roleId,
  roleSet,
  snapshot,
}) {
  const isNewRole = !roleSet || roleSet.has(roleId);

  const role = isNewRole
    ? normalize({
        library,
        role: snapshot.entities.roles[roleId],
        snapshot,
      })
    : snapshot.entities.roles[roleId];

  // In cases where the role isn't included in the current snapshot level.
  if (!role) {
    return;
  }

  if (deriveMetrics) {
    const group = role?.group_uuid
      ? snapshot.entities.groups[role.group_uuid]
      : null;

    role.__metrics.self = applyMetrics({
      activity,
      role,
      roleSet,
      group,
      metrics,
    });

    role.__percentage = percent(
      role.__metrics.self.visible.hours,
      role.__metrics.self.total.hours
    );

    role.__total_metrics = { ...role.__metrics.self.total };
    role.__visible_metrics = { ...role.__metrics.self.visible };
    metrics.set(role.uuid, { ...role.__metrics });
  }

  return role;
}
